<template>
  <div>
    <el-card shadow="never">
      <div class="group-info-top">
        <div class="top-list">
          <span class="label">群发标题</span>
          <span>{{ groupmsgInfo.title }}</span>
        </div>
        <div class="top-list">
          <span class="label">群发内容</span>
          <span>{{ groupmsgInfo.text }}</span>&nbsp;
          <el-button
            type="text"
            @click="showContentVisible = true"
          >
            预览
          </el-button>
        </div>
        <div class="top-list">
          <span class="label">发送范围</span>
          <span>
            <span v-if="groupmsgInfo.chat_range === 1">全部客户</span>
            <span v-else> 满足筛选条件下的{{ count }}名客户 </span>&nbsp;
            <el-button
              type="text"
              @click="showInfoVisible = true"
            >详情</el-button>
          </span>
        </div>
        <div class="top-list">
          <span class="label">推送时间</span>
          <span>{{ groupmsgInfo.sent_at_str }}</span>
        </div>
      </div>
    </el-card>

    <div class="grop-count m-t-20">
      <div
        v-for="(item, index) in countList"
        :key="index"
        class="count-list"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <div class="count">
          {{ item.count }}
        </div>
        <div v-if="item.tipsTitle">
          <span class="tips-title">{{ item.tipsTitle }}</span>
          <span>{{ item.tipsCount }}</span>
        </div>
      </div>
    </div>

    <div class="m-t-20">
      <InfoTable />
    </div>

    <Content
      v-model="showContentVisible"
      :attachment="groupmsgInfo.attachments"
    />
    <SendScope
      v-model="showInfoVisible"
      :groupmsg-info="groupmsgInfo"
      :count="count"
    />
  </div>
</template>

<script>
import InfoTable from './comps/customerGroupInfo/table.vue'
import Content from './comps/customerGroupInfo/content.vue'
import SendScope from './comps/customerGroupInfo/sendScope.vue'
export default {
  components: {
    InfoTable,
    Content,
    SendScope
  },
  data () {
    return {
      countList: [
        {
          name: 'salesperson_all_num',
          title: '本次推送员工',
          count: null
        },
        {
          name: 'salesperson_num',
          title: '已发送员工',
          count: null,
          tipsName: 'salesperson_wait_num',
          tipsTitle: '等待发送员工',
          tipsCount: null
        },
        {
          name: 'customer_all_num',
          title: '预计发送客户',
          count: null
        },
        {
          name: 'customer_num',
          title: '已送达客户',
          count: null,
          tipsName: 'customer_error_num',
          tipsTitle: '发送失败客户',
          tipsCount: null
        },
        {
          name: 'conversion_num',
          title: '活动转化客户',
          count: null,
          
        },
        {
          name: 'first_buy',
          title: '首购客户',
          count: null,
          tipsName: 'again_buy',
          tipsTitle: '复购客户',
          tipsCount: null
        },
        {
          name: 'order_fee',
          title: '活动变现（元）',
          count: null,
        }
        // {
        //   title: '已触达客户',
        //   count: null
        // }
        // {
        //   title: '活动转化客户',
        //   count: null
        // },{
        //   title: '首购客户',
        //   count: null,
        //   tipsTitle: '复购客户',
        //   tipsCount: null
        // },{
        //   title: '活动变现（元）',
        //   count: null
        // }
      ],
      list: [],
      groupmsgInfo: {},
      salespersonList: [],
      showContentVisible: false,
      showInfoVisible: false,
      count: 0
    }
  },
  mounted () {
    this.getInfo()
    this.getStatistic()
  },
  methods: {
    async getStatistic () {
      const params = this.$route.params
      const data = await this.$api.membership.getGroupmsgStatistic(params.id)
      if (data) {
        this.countList.forEach((v) => {
          Object.keys(data).forEach((key) => {
            if (v.name === key) {
              v.count = data[key]
            }
            if (v.tipsName === key) {
              v.tipsCount = data[key]
            }
          })
          if(v.name === 'order_fee') {
            v.count = (v.count/100).toFixed(2)
            }
        })
      }
    },
    async getInfo () {
      const params = this.$route.params
      const data = await this.$api.membership.getGroupmsgInfo(params.id)
      if (data) {
        console.log(data)
        this.groupmsgInfo = data
        this.getSendCount(data)
      }
    },
    async getSendCount (groupmsgInfo) {
      let params = {
        salesperson_ids: groupmsgInfo.salesperson.map((v) => v.salesperson_id),
        tag_ids: groupmsgInfo.tag.map((v) => v.id),
        tag_exclude_ids: groupmsgInfo.tag_exclude.map((v) => v.id),
        add_start_time: groupmsgInfo.add_start_time_str,
        add_end_time: groupmsgInfo.add_end_time_str,
        member_status: groupmsgInfo.member_status
      }
      const data = await this.$api.membership.sendCount(params)
      if (data) {
        this.count = data.count
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-t-20 {
  margin-top: 20px;
}
.group-info-top {
  .top-list {
    line-height: 24px;
    .label {
      color: #9a9097;
      margin-right: 20px;
    }
  }
}
.grop-count {
  border-radius: 4px;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .count-list {
    padding: 20px;
    border-right: 1px solid #ebeef5;
    flex: 1;
    .title {
      font-size: 13px;
      color: #9c9fa6;
    }
    .count {
      font-size: 24px;
      color: #606266;
      font-weight: 700;
      margin-bottom: 15px;
    }
    .tips-title {
      font-size: 12px;
      color: #9c9fa6;
      margin-right: 8px;
    }
  }
}
</style>
